import { removeSpecialCharAndNumFn1, sliceText } from "../../../utils/common";
import { safeString } from "../../../utils/logger";
// import { useEmployeeContext } from "../../../context/employee-context";

// const {
//     employeeInfo: imployeeInfoFromDB,
//     employeeProfileUILoading
// } = useEmployeeContext() || {};

export const EXIT_FORMALITY_INITIAL_STATE = {
    exit_date: "",
    settlement_date: "",
    reason_for_exit: "",
}
export const EXIT_FORMALITY_FIELDS = {
    exit_date: {
        name: "exit_date",
        label: "Exit Date ",
        type: "date",
        inputType: "inputField",
        component: "InputField",
        fullWidth: true,
        placeholder: "Select Here...",
        required: true,
        // max:maxDate,
        // min:imployeeInfoFromDB?.join_date
    },
    settlement_date: {
        name: "settlement_date",
        label: "Settlement Date",
        type: "date",
        inputType: "inputField",
        component: "InputField",
        fullWidth: true,
        placeholder: "Select Here...",
        required: true,
        // max:maxDate,
        // min:today
    },
    reason_for_exit: {
        name: "reason_for_exit",
        inputType: "inputField",
        component: "InputField",
        label: "Exit Reason",
        fullWidth: true,
        required: true,
        placeholder: "Type Here...",
        customOptions: {
            formatValueFn: (value) => {
                return sliceText(removeSpecialCharAndNumFn1(safeString(value), 150))
            }
        }
    }
}
export const EXIT_FORMALITY_API = {
    EXIT_FORMALITY_CREATE: { url: "/employee/employee-exit-formality", method: "POST" },
    EXIT_FORMALITY_UPDATE: { url: "/employee/employee-exit-formality", method: "POST" },
    EXIT_FORMALITY_GET: { url: "/employee/employee-exit-formality", method: "GET" }
}